import React, { useEffect, useState, useCallback, useMemo } from 'react'

import { GlobalState } from './GlobalContext';
import Dialog from '@mui/material/Dialog';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import LoginIcon from '@mui/icons-material/Login';
import { useForm, Controller } from "react-hook-form";
import dayjs from 'dayjs';

import * as DmsService from '../supports/dms-service';
import * as DmsCommon from '../supports/dms-common.js';


function SignInDialog(props) {

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);


  const { onClose, open } = props;
  const [showLoading, setShowLoading] = useState(false)

  const domains = ["hq.hk.hld", "hr.hk.hld", "cn1.hk.hld", "ext.hk.hld", "nd.hk.hld", "nd.cn.hld", "icpm.hld.com"]

  const [showPwd, setShowPwd] = useState(false)


  const hldLoginUrl = process.env.REACT_APP_HLD_LOGIN_URL || "";
  // console.log("hldLoginUrl:", hldLoginUrl);
  const useHldLogin = hldLoginUrl.length > 0;
  // console.log("useHldLogin:", useHldLogin);

  const [showError, setShowError] = useState(false)
  const [errMsg, setErrMsg] = useState("")


  useEffect(() => {
    if (open) {
      if (useHldLogin) {
        document.title = "DMS - Redirecting to HLD Login..."

        onHldLoginClick();
      }
    }
  }, [open])

  // Setup inital form values
  const defaultFormValues = {
    userID: gState.userID || "",
    password: "",
    domain: (domains.includes(gState.domain) ? gState.domain : domains[0]),
  }

  // React Hook the form
  const { control, handleSubmit, setValue } = useForm({
    defaultValues: defaultFormValues
  });




  const onSubmit = data => {

    // console.log(data);

    setShowError(false);
    setShowLoading(true);

    // Encode escape chars
    let vPassword = data.password.replace('%', '&#37;').replace('\\', '&#92;').replace('"', '&#34;').replace('=', '&#61;');

    DmsService.logonPromise(data.domain, data.userID, vPassword)
      .then((AResultData) => {
        // console.log('logonPromise return', AResultData);

        setShowLoading(false)

        const vDispatchValues = DmsService.digestDataAfterAuth(data.userID, data.domain, null, AResultData)

        gStateDispatch(vDispatchValues);

      })
      .catch((e) => {
        setShowLoading(false)

        console.log('Fail return: ', e);

        setErrMsg(e.errMsg || e.message);
        setShowError(true);

      })
  }

  const onHldLoginClick = () => {
    var vQueryStr = window.location.search.substring(1);
    // console.log("Current query string: ", vQueryStr);

    // const vBrowserInfo = DmsCommon.getBrowserInfo();

    // const vLogonInfo =
    //   "&appVer=" + process.env.REACT_APP_VER +
    //   "&device=" + vBrowserInfo.name +
    //   "&deviceVer=" + vBrowserInfo.version;

    if (vQueryStr.length > 0) {
      window.location.href = hldLoginUrl + "&" + vQueryStr;
    } else {
      window.location.href = hldLoginUrl;
    }
  }

  useEffect(() => {
    if (open) {
      // For refreshing in App page
      localStorage.signInPassFlag = '1'

      setValue("password", "");

      onClose && onClose();
    }
  }, [gState])

  return (
    <Dialog open={open}  >
      {/* <SignIn /> */}

      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={2}>
              <Avatar src="images/henderson-logo-2026.png" sx={{ width: 32, height: 32 }} />
            </Grid>
            <Grid item xs={8}>
              <Typography variant="h6" noWrap component="div" align="center" sx={{ flexGrow: 1 }}>
                DMS
              </Typography>
            </Grid>

          </Grid>


          <Box component="form" onSubmit={handleSubmit(onSubmit)} >
            {useHldLogin && <>
              <Button
                type="button"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={onHldLoginClick}
                startIcon={<LoginIcon />}
              >
                Login
              </Button>

            </>}

            {useHldLogin === false && <>

              <Controller
                name="userID"
                control={control}
                render={({ field }) =>
                  <TextField
                    {...field}
                    margin="normal"
                    fullWidth
                    required
                    label="Login ID"
                    autoFocus
                  />
                }
              />

              <Controller
                name="password"
                control={control}
                render={({ field }) =>
                  <TextField
                    {...field}
                    margin="normal"
                    required
                    fullWidth
                    label="Password"
                    type={showPwd ? 'text' : 'password'}
                    autoComplete="current-password"
                    InputProps={{
                      endAdornment:
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPwd(!showPwd)}
                            onMouseDown={() => event.preventDefault()}
                            edge="end"
                          >
                            {showPwd ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                    }}

                  />
                }
              />
              <Controller
                name="domain"
                control={control}
                render={({ field }) =>
                  <TextField
                    {...field}
                    margin="normal"
                    required
                    fullWidth
                    select
                    label="Domain"
                  >
                    {domains.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                }
              />



              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Login
              </Button>
            </>}




            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={showLoading}

            >
              <CircularProgress color="inherit" />
            </Backdrop>
            {showError &&
              <Alert severity="error">{errMsg}</Alert>
            }
          </Box>
        </Box>

        <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 4 }} >
          {`Copyright © Henderson Land Development Co. Ltd. 2021 `}
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 4 }} >
          {"Ver. " + process.env.REACT_APP_VER}
        </Typography>
      </Container>


    </Dialog>
  );
}

SignInDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  userID: PropTypes.string,
  domain: PropTypes.string
};

export default SignInDialog

